import React from "react";
import PropTypes from "prop-types";
import "./InputField.scss";

const InputField = ({
  label,
  as: Component = "input",
  inputRef,           // 👈 extract it here
  ...props
}) => (
  <div className="input-field">
    {label && <label htmlFor={props.id}>{label}</label>}
    
    <Component
      ref={inputRef}   // 👈 use it correctly
      {...props}       // 👈 now inputRef is not forwarded
    />
  </div>
);

InputField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  as: PropTypes.elementType,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
};

export default InputField;
